<template>
    <div>
		<div class="row">
			<div class="col-md-4">
				<div class="mb-2">Режим замедления времени</div>
				<b-form-select
					class="mb-2"
					v-model="currentEasing"
					@change="changeEasing"
					:options="easings"
				></b-form-select>
			</div>
			<div class="col-md-4">
				<div class="mb-2">Скорость: {{ speed/1000 }}(сек)</div>
				<b-form-input
					:disabled="!isSelected"
					v-model="speed"
					type="range"
					min="500"
					max="10000"
					step="500"
				></b-form-input>
			</div>
			<div class="col-md-4"></div>
		</div>
		<div class="mb-2">
			Добавить анимацию
		</div>
		<div class="my-button-group">
			<b-button
				v-for="animation in animations"
				:key="animation"
				@click="setAnimation(animation)"
				:disabled="!isSelected"
				variant="outline-secondary"
				size="sm"
			>
				{{ animation }}
			</b-button>
		</div>
		<div class="text-right">
			<b-button
				pill
				variant="outline-primary"
				@click="cancelAnimation"
				:disabled="!isSelected"
				size="sm"
			>
				Сбросить
			</b-button>
		</div>
    </div>
</template>

<script>
import { fabric } from "fabric";

const getRandomArbitrary = (min, max) => {
	return Math.random() * (max - min) + min;
};

export default {
    props:[
        'canvas',
        'isSelected'
    ],
    data(){
        return {
            currentEasing: "easeInOutCubic",
			animations: [
				"animateBlink",
				"animateMoveY",
				"animateMoveX",
				"animateRotate",
				"animateRandomPos",
				"animateScale",
			],
            speed: 500,
			easings: [
				"easeInBack",
				"easeInBounce",
				"easeInCirc",
				"easeInCubic",
				"easeInElastic",
				"easeInExpo",
				"easeInOutBack",
				"easeInOutBounce",
				"easeInOutCirc",
				"easeInOutCubic",
				"easeInOutElastic",
				"easeInOutExpo",
				"easeInOutQuad",
				"easeInOutQuart",
				"easeInOutQuint",
				"easeInOutSine",
				"easeInQuad",
				"easeInQuart",
				"easeInQuint",
				"easeInSine",
				"easeOutBack",
				"easeOutBounce",
				"easeOutCirc",
				"easeOutCubic",
				"easeOutElastic",
				"easeOutExpo",
				"easeOutQuad",
				"easeOutQuart",
				"easeOutQuint",
				"easeOutSine",
			],
        }
    },
    methods:{
        changeEasing() {
			console.log(this.currentEasing);
		},
		cancelAnimation() {
			const obj = this.canvas.getActiveObject();
			if (obj.isAnimAborted === false) {
				obj.isAnimAborted = true;

				this.canvas.add(obj.cloned);
				this.canvas.remove(obj);
				this.canvas.setActiveObject(obj.cloned);
				this.canvas.requestRenderAll();
			}
		},
		setAnimation(animationName) {
			this.cancelAnimation();
			const obj = this.canvas.getActiveObject();
			const canvas = this.canvas;
			const speed = Number(this.speed);
			const left = obj.left;
			const easing = fabric.util.ease[this.currentEasing];
			const top = obj.top;
			const angle = obj.angle;
			obj.clone((cloned) => {
				obj.set({
					cloned,
				});
			});

			obj.set({
				isAnimAborted: false,
			});

			switch (animationName) {
				case "animateRandomPos": {
					const anim = () => {
						var randomX = Math.round(
							getRandomArbitrary(
								0,
								canvas.width - obj.width * obj.scaleX,
							),
						);
						var randomY = Math.round(
							getRandomArbitrary(
								0,
								canvas.height - obj.height * obj.scaleY,
							),
						);
						// console.log(randomX, randomY);
						obj.animate(
							{ left: randomX, top: randomY },
							{
								duration: speed,
								// onChange: canvas.renderAll.bind(canvas),
								onChange: canvas.renderAndResetBound,
								easing: easing,
								abort: function() {
									if (obj.isAnimAborted) {
										clearInterval(interval);
									}
									return obj.isAnimAborted;
								},
							},
						);
					};
					const interval = setInterval(anim, speed * 2);

					break;
				}
				case "animateMoveX":
					obj.set({
						direction: true,
					});

					(function loop(dir) {
						let options = {
							easing: easing,
							duration: speed,
						};

						obj.animate(
							{
								left: dir ? left + 100 : left,
							},
							fabric.util.object.extend(
								{
									onChange: canvas.renderAndResetBound,
									onComplete: function() {
										obj.direction = !obj.direction;
										loop(obj.direction);
									},
									abort: function() {
										return obj.isAnimAborted;
									},
								},
								options,
							),
						);
					})(true);
					break;
				case "animateMoveY":
					obj.set({
						direction: true,
					});

					(function loop(dir) {
						let options = {
							easing: easing,
							duration: speed,
						};
						

						obj.animate(
							{
								top: dir ? top + 100 : top,
							},
							fabric.util.object.extend(
								{
									onChange: canvas.renderAndResetBound,
									onComplete: function() {
										obj.direction = !obj.direction;
										loop(obj.direction);
									},
									abort: function() {
										return obj.isAnimAborted;
									},
								},
								options,
							),
						);
					})(true);
					break;
				case "animateBlink":
					obj.set({
						direction: true,
					});

					(function loop(dir) {
						let min = 0;
						let max = 1;

						let options = {
							easing: easing,
							duration: speed,
						};

						obj.animate(
							{
								opacity: dir ? max : min,
							},
							fabric.util.object.extend(
								{
									onChange: canvas.renderAndResetBound,
									onComplete: function() {
										obj.direction = !obj.direction;
										loop(obj.direction);
									},
									abort: function() {
										return obj.isAnimAborted;
									},
								},
								options,
							),
						);
					})(true);
					break;
				case "animateRotate":
					obj.set({
						originX: "center",
						originY: "center",
						direction: true,
					});

					(function loop(dir) {
						var options = {
							easing: easing,
							duration: speed,
						};

						obj.animate(
							{
								angle: dir ? angle + 360 : angle,
							},
							fabric.util.object.extend(
								{
									onChange: canvas.renderAndResetBound,
									onComplete: function() {
										obj.direction = !obj.direction;
										loop(obj.direction);
									},
									abort: function() {
										return obj.isAnimAborted;
									},
								},
								options,
							),
						);
					})(true);
					break;
				case "animateScale":
					obj.set({
						direction: true,
						originX: "center",
						originY: "center",
					});
					var minScale = obj.scaleX,
						maxScale = obj.scaleX + (obj.scaleX / 100 * 50);
					(function loop(dir) {
						var options = {
							easing: easing,
							duration: speed,
						};

						obj.animate(
							{
								scaleX: dir ? maxScale : minScale,
								scaleY: dir ? maxScale : minScale,
							},
							fabric.util.object.extend(
								{
									onChange: canvas.renderAndResetBound,
									onComplete: function() {
										obj.direction = !obj.direction;
										loop(obj.direction);
									},
									abort: function() {
										return obj.isAnimAborted;
									},
								},
								options,
							),
						);
					})(true);
					break;
				default:
					console.log("defautl");
					break;
			}
		},
    }
}
</script>

<style>

</style>